// Currently this is for both the reporting site and dashboard,
import { DocumentType } from "../../__generated__/graphql";

// hopefully they will continue to use the same URL patterns indefintely.
export const URL_PARTS: Record<DocumentType, string> = {
  [DocumentType.DataInsightReport]: "insights",
};
